<template>
    <div class="form-group select_date_box">
        <label for="delivery-modal-time-picker">{{ form.is_pickup == 1 ? trans('step1.fitting_time','Fitting Time') : trans('step1.delivery_time','Delivery Time') }}</label>
        <select id="delivery-modal-time-picker" v-model="delivery_time"
                name="delivery_time" class="form-control selectpicker select_box_input"
                :disabled="!form.delivery_date" @change="focusNextButton">
            <option value="">{{trans('step1.select_btn')}}</option>
            <option v-for="(time, key, index) in delivery_times" :value="key"
                    :disabled="time.is_disable">{{ time.text }}
            </option>
        </select>
    </div>
</template>
<script>
import {mapGetters, mapState} from "vuex";


export default {
    name: 'DeliveryTimePicker',
    computed:{
        delivery_time: {
            get() {
                return this.$store.state.form.delivery_time;
            },
            set(value) {
                this.$store.commit('SET_DELIVERY_TIME', value)
                this.$store.commit('SET_FIRST_DAY_SKIING')
            }
        },
        ...mapState(['form', 'delivery_times'])
    },
    methods: {
        trans(key, defaultValue,msg=null) {
            let translation = '';
            if(msg){
                translation = this.$t(key,{message:msg});
            }else{
                translation = this.$t(key);
            }
            return translation !== key ? translation : defaultValue;
        },
        focusNextButton(){
            let buttonEle = document.getElementById('delivery-select');
            if(buttonEle){
                this.cursorFocus(buttonEle, 'nearest')
            }
        },
        cursorFocus(elem, block='nearest') {
            setTimeout(() => {
                const dropdownMenu = elem.closest('.bs3-drp-menu');
                if (dropdownMenu) {
                    dropdownMenu.scrollTop = dropdownMenu.scrollHeight;
                }
                elem.focus();
                elem.scrollIntoView({behavior: "smooth", block: block});
            }, 100);
        },
    }
}
</script>
